import React from "react";
import { createPortal } from "react-dom";
import { Button } from "../ui/button";
import { Trash2 } from "lucide-react";

type DeleteTarget = { id: string; name?: string } | null;

type Props = {
  open: boolean;
  target: DeleteTarget;
  onClose: () => void;
  onConfirm: (id: string) => Promise<void> | void;
};

export default function RenewalDeleteConfirm({ open, target, onClose, onConfirm }: Props) {
  if (!open || !target) return null;

  const handleConfirm = async () => {
    await onConfirm(target.id);
  };

  const modal = (
    <div className="fixed inset-0 z-[99999] bg-black bg-opacity-40 flex items-center justify-center px-4" role="dialog" aria-modal="true">
      <div className="bg-white rounded-xl shadow-xl max-w-sm w-full overflow-hidden">
        <div className="p-5">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-rose-50 border border-rose-200 flex items-center justify-center">
              <Trash2 className="h-6 w-6 text-rose-500" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900">Eliminar campaña</h3>
              <p className="mt-2 text-sm text-gray-600">
                ¿Estás seguro de que deseas eliminar la campaña <span className="font-semibold text-gray-900">"{target.name ?? ""}"</span>? Esta acción no se puede deshacer.
              </p>
            </div>
          </div>
        </div>

        <div className="px-5 pb-5">
          <div className="flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              className="px-5 h-10 rounded-lg border-gray-200 hover:bg-gray-50"
            >
              Cancelar
            </Button>
            <Button
              className="px-5 h-10 rounded-lg bg-rose-600 hover:bg-rose-700 text-white font-medium shadow-sm transition-all"
              onClick={handleConfirm}
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Eliminar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  return typeof document !== "undefined" ? createPortal(modal, document.body) : modal;
}
